export type FormType =
  | 'instant-demo'
  | 'personalized-demo'
  | 'case-study'
  | 'ready-to-get-started'
  | 'footer-demo'
  | 'hero-email-capture'
  | 'pricing-form';

export interface FormSubmissionData {
  name?: string;
  email: string;
  formType: FormType;
  phone?: string;
  brokerage?: string;
}

export interface FormSubmissionResponse {
  success: boolean;
  message: string;
  submission?: {
    date: string;
    time: string;
    name?: string;
    email: string;
    formType: FormType;
    phone?: string;
    brokerage?: string;
  };
  error?: string;
}

export const submitForm = async (
  data: FormSubmissionData
): Promise<FormSubmissionResponse> => {
  try {
    // Determine API endpoint
    const apiUrl =
      import.meta.env.VITE_API_BASE_URL ||
      (import.meta.env.DEV ? 'http://localhost:3000/api' : '/api');

    const response = await fetch(`${apiUrl}/submit-form`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({
        error: 'Failed to submit form'
      }));
      throw new Error(errorData.error || 'Failed to submit form');
    }

    return await response.json();
  } catch (error) {
    console.error('Form submission error:', error);
    throw error;
  }
};
